import React, { useState, useEffect, useRef } from 'react';
import {
  A11Y_THEMES, A11Y_MIN, A11Y_MAX, loadA11y, saveA11y, announceListView,
} from '../utils/accessibility';

const STEP = 15;

const AccessibilityControl = () => {
  const [open, setOpen] = useState(false);
  const [s, setS] = useState(loadA11y);
  const btnRef = useRef(null);

  const update = (patch) => {
    const next = { ...s, ...patch };
    setS(next);
    saveA11y(next);
  };

  const toggleEnabled = (enabled) => {
    update({ enabled });
    if (enabled) announceListView();
  };

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); setOpen(false); if (btnRef.current) btnRef.current.focus(); } };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [open]);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        ref={btnRef} type="button" className="btn-secondary a11y-toggle-btn"
        aria-expanded={open} aria-controls="a11y-panel" onClick={() => setOpen((v) => !v)}
        title="Accessibility settings"
      >
        Aa Accessibility{s.enabled ? ' (on)' : ''}
      </button>
      {open && (
        <div
          id="a11y-panel" role="group" aria-label="Accessibility settings" className="a11y-panel"
        >
          <label className="a11y-row a11y-main">
            <input type="checkbox" checked={s.enabled} onChange={(e) => toggleEnabled(e.target.checked)} />
            <span>Accessible view (larger text, high contrast, list layout)</span>
          </label>

          <fieldset className="a11y-fieldset" disabled={!s.enabled}>
            <legend>Colour theme</legend>
            {A11Y_THEMES.map((t) => (
              <label key={t.id} className="a11y-row">
                <input type="radio" name="a11y-theme" checked={s.theme === t.id} onChange={() => update({ theme: t.id })} />
                <span>{t.label}</span>
              </label>
            ))}
          </fieldset>

          <div className="a11y-row" role="group" aria-label="Text size">
            <span>Text size: <strong aria-live="polite">{s.scale}%</strong></span>
            <button type="button" className="btn-secondary" disabled={!s.enabled || s.scale <= A11Y_MIN}
              onClick={() => update({ scale: Math.max(A11Y_MIN, s.scale - STEP) })} aria-label="Make text smaller">A−</button>
            <button type="button" className="btn-secondary" disabled={!s.enabled || s.scale >= A11Y_MAX}
              onClick={() => update({ scale: Math.min(A11Y_MAX, s.scale + STEP) })} aria-label="Make text larger">A+</button>
          </div>

          <p className="a11y-note">Saved in this browser. Press Escape to close. Dialogs can be closed with Escape too.</p>
        </div>
      )}
    </div>
  );
};

export default AccessibilityControl;
